import React, { useCallback } from 'react'
import { connect } from 'dva'
import { Modal } from 'antd'
import PageWrapper from '@/components/PageWrapper'
import IconFont from '@/components/Icon'
import AddBankCard from './AddBankCard'
import './Info.module.less'

const option = [
  {
    key: 'init',
    icon: 'iconshezhi',
    name: '设为默认',
  },
  {
    key: 'edit',
    icon: 'iconbianji',
    name: '编辑详情',
  },
  {
    key: 'delete',
    icon: 'iconshanchu',
    name: '删除卡片',
  },
]
const BankCard = ({ dispatch, bankList }) => {
  const handleSetInit = useCallback(
    (item) => {
      const payload = {
        body: {
          isDefault: 1,
        },
        query: {
          id: item.id,
        },
      }
      dispatch({
        type: 'center/editPersonalBankCard',
        payload,
      }).then(() => {
        dispatch({
          type: 'global/getPersonalBankCards',
        })
      })
    },
    [dispatch]
  )

  const handleEdit = useCallback(
    (item) => {
      dispatch({
        type: 'center/getPersonalBankCardDetail',
        payload: {
          params: {
            id: item.id,
          },
        },
      }).then(() => {
        dispatch({
          type: 'center/save',
          payload: {
            bankCardVisible: true,
            isEditBank: true,
          },
        })
      })
    },
    [dispatch]
  )

  const handleDelete = useCallback(
    (item) => {
      Modal.confirm({
        centered: true,
        content: '确认删除该银行卡吗？',
        okText: '确认',
        cancelText: '取消',
        onOk: () => {
          dispatch({
            type: 'center/deletePersonalBankCard',
            payload: {
              params: {
                id: item.id,
              },
            },
          }).then(() => {
            dispatch({
              type: 'global/getPersonalBankCards',
            })
          })
        },
      })
    },
    [dispatch]
  )

  const handleAddBankCard = useCallback(() => {
    dispatch({
      type: 'center/save',
      payload: {
        bankCardVisible: true,
        isEditBank: false,
      },
    })
  }, [dispatch])

  const handleClickEditInfo = useCallback(
    (key, item) => {
      if (key === 'init') {
        if (item.isDefault === 0) {
          handleSetInit(item)
        }
      } else if (key === 'edit') {
        handleEdit(item)
      } else {
        handleDelete(item)
      }
    },
    [handleSetInit, handleEdit, handleDelete]
  )

  return (
    <div style={{ marginTop: '-40px' }}>
      <PageWrapper
        subTitle={
          <div styleName="query-box">
            <span styleName="title">银行卡管理</span>
          </div>
        }
      >
        <div style={{ overflow: 'hidden' }}>
          {bankList.map((it) => (
            <div styleName="card" key={it.id}>
              <div styleName="info">
                <div title={it.bankName} styleName="top">
                  {it.bankName}
                </div>
                <div styleName="bottom">{it.cardNumber}</div>
              </div>
              <div styleName="option">
                {option.map((optionItem) => (
                  <div
                    styleName={
                      it.isDefault === 1 && optionItem.key === 'init'
                        ? 'is-disabled'
                        : ''
                    }
                    key={optionItem.key}
                    onClick={() => handleClickEditInfo(optionItem.key, it)}
                  >
                    <IconFont type={optionItem.icon} />
                    {optionItem.key === 'init' && it.isDefault === 1 ? (
                      <span>默认</span>
                    ) : (
                      <span>{optionItem.name}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
          ))}
          <div onClick={handleAddBankCard} styleName="card empty">
            <IconFont styleName="icon" type="iconzengjia" />
            <span>新增银行卡</span>
          </div>
        </div>
      </PageWrapper>
      <AddBankCard />
    </div>
  )
}

export default connect(({ global }) => {
  return {
    bankList: global.banks,
  }
})(BankCard)
